module.exports = __webpack_public_path__ + "img/yjdy.d7665b20.png";